<template>
  <div>
    <div style="margin: 10px 0">
      <el-input style="width: 200px" placeholder="请输入项目名称" suffix-icon="el-icon-search" v-model="name"></el-input>
      <el-select v-model="typeId" placeholder="请选择项目类型" style="width: 200px" class="ml-5">
        <el-option v-for="item in typeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="status" placeholder="请选择状态" style="width: 200px" class="ml-5">
        <el-option label="已发布" :value="1"></el-option>
        <el-option label="草稿" :value="2"></el-option>
      </el-select>
      <el-button class="ml-5" type="primary" @click="load">搜索</el-button>
      <el-button type="warning" @click="reset">重置</el-button>
    </div>

    <div style="margin: 10px 0">
      <el-button type="primary" @click="handleAdd">新增 <i class="el-icon-circle-plus-outline"></i></el-button>
    </div>

    <!-- 卡片式布局 -->
    <div class="project-grid">
      <div class="project-card" v-for="item in tableData" :key="item.id">
        <!-- 封面图 -->
        <div class="card-cover">
          <img :src="item.coverPath" :alt="item.name" />
          <el-tag class="status-tag" :type="item.status === 1 ? 'success' : 'info'">
            {{ item.status === 1 ? '已发布' : '草稿' }}
          </el-tag>
        </div>

        <!-- 内容区 -->
        <div class="card-content">
          <!-- 标题和类型 -->
          <div class="card-header">
            <h3 class="card-title">{{ item.name }}</h3>
            <el-tag size="small" type="primary">{{ item.typeName }}</el-tag>
          </div>

          <!-- 推荐指数 -->
          <div class="card-rate">
            <el-rate v-model="item.recommendationRate" disabled show-score text-color="#e6a23c"></el-rate>
          </div>

          <!-- 简介 -->
          <p class="card-intro">{{ item.intro }}</p>

          <!-- 标签 -->
          <div class="card-tags">
            <el-tag v-for="tag in item.tag.split(',')" :key="tag" size="small" 
              style="background-color: #858cf4; color: #fff; border: none; margin-right: 5px; margin-bottom: 5px;">
              {{ tag }}
            </el-tag>
          </div>

          <!-- 价格 -->
          <div class="card-price">
            <span class="original-price">原价：¥{{ item.originalPride }}</span>
            <span class="discounted-price">优惠价：¥{{ item.discountedPrice }}</span>
          </div>

          <!-- 创建信息 -->
          <div class="card-info">
            <span class="creator">{{ item.creatorName }}</span>
            <span class="time">{{ item.createTime }}</span>
          </div>

          <!-- 操作按钮 -->
          <div class="card-actions">
            <el-button size="small" type="primary" @click="showDescription(item)">
              <i class="el-icon-document"></i> 描述
            </el-button>
            <el-button size="small" type="success" @click="handleEdit(item)">
              <i class="el-icon-edit"></i> 编辑
            </el-button>
            <el-popconfirm confirm-button-text='确定' cancel-button-text='我再想想' 
              icon="el-icon-info" icon-color="red" title="您确定删除吗？" @confirm="del(item.id)">
              <el-button size="small" type="danger" slot="reference">
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </el-popconfirm>
          </div>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div style="padding: 10px 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[4, 8, 12, 16]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog title="项目信息" :visible.sync="dialogFormVisible" width="800px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="small">

        <el-form-item label="项目名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="项目类型" prop="typeId">
          <el-select v-model="form.typeId" placeholder="请选择项目类型" style="width: 100%">
            <el-option v-for="item in typeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
   
        <el-form-item label="项目简介" prop="intro">
          <el-input v-model="form.intro" type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="原价" prop="originalPride">
              <el-input-number v-model="form.originalPride" :precision="2" :step="0.1" :min="0" style="width: 100%"
                @change="validatePrice"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠价" prop="discountedPrice">
              <el-input-number v-model="form.discountedPrice" :precision="2" :step="0.1" :min="0" style="width: 100%"
                @change="validatePrice"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="项目标签" prop="tag">
          <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)"
            size="small" style="margin-right: 10px; margin-bottom: 10px; height: 32px; line-height: 30px;">
            {{ tag }}
          </el-tag>
          <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
            @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"
            style="width: 90px; vertical-align: top;">
          </el-input>
          <el-button v-else-if="dynamicTags.length < 10" class="button-new-tag" size="small" @click="showInput">+
            添加标签</el-button>
          <el-tag v-else size="small" type="info" style="margin-left: 10px;">最多10个标签</el-tag>
        </el-form-item>
        <el-form-item label="推荐指数" prop="recommendationRate">
          <el-rate v-model="form.recommendationRate" :max="5" show-score style="margin-top: 7px;"></el-rate>
        </el-form-item>
        <el-form-item label="封面图片" prop="coverPath">
          <el-upload class="avatar-uploader" action="http://localhost:9090/file/upload" :show-file-list="false"
            :on-success="handleCoverSuccess">
            <img v-if="form.coverPath" :src="form.coverPath" class="avatar" style="object-fit: cover">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频" prop="videoPath">
          <el-input v-model="form.videoPath" placeholder="请输入视频链接"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">发布</el-radio>
            <el-radio :label="2">草稿</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加抽屉组件 -->
    <el-drawer title="项目描述" :visible.sync="drawerVisible" direction="rtl" size="70%" :before-close="handleDrawerClose">
      <div style="padding: 20px;">
        <el-form size="small" style="width: 100%" :model="descriptionForm" ref="descriptionForm">
          <el-form-item prop="description" required>
            <mavon-editor style="height: 700px" ref="md" v-model="descriptionForm.description" :ishljs="true" @imgAdd="imgAdd" />
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-top: 20px;">
          <el-button @click="handleDrawerClose">取 消</el-button>
          <el-button type="primary" @click="saveDescription">确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "Project",
  data() {
    // 添加价格验证规则
    const validateDiscountedPrice = (rule, value, callback) => {
      if (value >= this.form.originalPride) {
        callback(new Error('优惠价必须低于原价'))
      } else {
        callback()
      }
    }
    return {
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 4,
      name: "",
      typeId: "",
      status: "",
      form: {
        id: '',
        typeId: '',
        name: '',
        intro: '',
        description: '',
        originalPride: '',
        discountedPrice: '',
        tag: '',
        recommendationRate: 0,
        coverPath: '',
        videoPath: '',
        status: 1
      },
      rules: {
        typeId: [{ required: true, message: '请选择项目类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        intro: [{ required: true, message: '请输入项目简介', trigger: 'blur' }],
        description: [{ required: true, message: '请输入项目描述', trigger: 'blur' }],
        originalPride: [{ required: true, message: '请输入原价', trigger: 'blur' }],
        discountedPrice: [
          { required: true, message: '请输入优惠价', trigger: 'blur' },
          { validator: validateDiscountedPrice, trigger: 'blur' }
        ],
        tag: [{ required: true, message: '请输入项目标签', trigger: 'blur' }],
        recommendationRate: [{ required: true, message: '请选择推荐指数', trigger: 'change' }],
        coverPath: [{ required: true, message: '请上传封面图片', trigger: 'change' }],
        videoPath: [{ required: true, message: '请输入视频链接', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      dialogFormVisible: false,
      multipleSelection: [],
      typeOptions: [],
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      drawerVisible: false,
      currentProject: {},
      descriptionForm: {
        id: '',
        description: ''
      },
    }
  },
  created() {
    this.load()
    this.loadTypes()
  },
  methods: {
    // 绑定@imgAdd event
    imgAdd(pos, $file) {
      let $vm = this.$refs.md
      // 第一步.将图片上传到服务器.
      const formData = new FormData();
      formData.append('file', $file);
      axios({
        url: 'http://localhost:9090/file/upload',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((res) => {
        // 第二步.将返回的url替换到文本原位置![...](./0) -> ![...](url)
        $vm.$img2Url(pos, res.data);
      })
    },
    loadTypes() {
      this.request.get("/projectType/children").then(res => {
        this.typeOptions = res.data
      })
    },
    handleCoverSuccess(res) {
      this.form.coverPath = res
      this.$message.success('上传成功')
    },
    handleVideoSuccess(res) {
      this.form.videoPath = res.data
      this.$message.success('上传成功')
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.request.post("/project", this.form).then(res => {
            if (res.code === '200') {
              this.$message.success("保存成功")
              this.dialogFormVisible = false
              this.load()
            } else {
              this.$message.error("保存失败")
            }
          })
        }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form = {
        typeId: '',
        name: '',
        intro: '',
        description: '',
        originalPride: '',
        discountedPrice: '',
        tag: '',
        recommendationRate: 0,
        coverPath: '',
        videoPath: '',
        status: 1
      }
      this.dynamicTags = []
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    load() {
      this.request.get("/project/page", {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          name: this.name,
          typeId: this.typeId,
          status: this.status
        }
      }).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },
    handleEdit(row) {
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
        this.form = JSON.parse(JSON.stringify(row))
        this.dynamicTags = this.form.tag ? this.form.tag.split(',') : []
      })
    },
    del(id) {
      this.request.delete("/project/" + id).then(res => {
        if (res.code === '200') {
          this.$message.success("删除成功")
          this.load()
        } else {
          this.$message.error("删除失败")
        }
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val
    },
    delBatch() {
      if (!this.multipleSelection.length) {
        this.$message.error("请选择需要删除的数据")
        return
      }
      let ids = this.multipleSelection.map(v => v.id)  // [{}, {}, {}] => [1,2,3]
      this.request.post("/project/del/batch", ids).then(res => {
        if (res.code === '200') {
          this.$message.success("批量删除成功")
          this.load()
        } else {
          this.$message.error("批量删除失败")
        }
      })
    },
    reset() {
      this.name = ""
      this.typeId = ""
      this.status = ""
      this.load()
    },
    handleSizeChange(pageSize) {
      console.log(pageSize)
      this.pageSize = pageSize
      this.load()
    },
    handleCurrentChange(pageNum) {
      console.log(pageNum)
      this.pageNum = pageNum
      this.load()
    },
    // 添加价格验证方法
    validatePrice() {
      // 当两个价格都有值时，触发表单验证
      if (this.form.originalPride !== '' && this.form.discountedPrice !== '') {
        this.$refs.form.validateField('discountedPrice')
      }
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.form.tag = this.dynamicTags.join(',');
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue && this.dynamicTags.length < 10) {
        this.dynamicTags.push(inputValue);
        this.form.tag = this.dynamicTags.join(',');
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    showDescription(row) {
      this.descriptionForm.id = row.id;
      this.descriptionForm.description = row.description || '';
      this.drawerVisible = true;
    },
    handleDrawerClose() {
      this.descriptionForm = {
        id: '',
        description: ''
      };
      this.drawerVisible = false;
    },
    saveDescription() {
      // 构建完整的project对象
      const project = {
        id: this.descriptionForm.id,
        description: this.descriptionForm.description
      };
      this.request.post("/project", project).then(res => {
        if (res.code === '200') {
          this.$message.success("保存成功");
          this.handleDrawerClose();
          this.load();
        } else {
          this.$message.error("保存失败");
        }
      });
    },
  }
}
</script>

<style>
.headerBg {
  background: #eee !important;
}

/* 卡片网格布局 */
.project-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin: 20px 0;
}

/* 项目卡片 */
.project-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  transition: box-shadow 0.3s;
  display: flex;
  flex-direction: column;
}

.project-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 封面图 */
.card-cover {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: #f5f5f5;
}

.card-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.status-tag {
  position: absolute;
  top: 10px;
  right: 10px;
}

/* 内容区 */
.card-content {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* 标题和类型 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  flex: 1;
  margin-right: 10px;
}

/* 推荐指数 */
.card-rate {
  margin-bottom: 12px;
}

.card-rate .el-rate {
  height: 20px;
}

/* 简介 */
.card-intro {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0 0 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 标签 */
.card-tags {
  margin-bottom: 12px;
  min-height: 28px;
}

/* 价格 */
.card-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 12px;
}

.card-price .original-price {
  color: #999;
  text-decoration: line-through;
  font-size: 13px;
}

.card-price .discounted-price {
  color: #f56c6c;
  font-weight: bold;
  font-size: 16px;
}

/* 创建信息 */
.card-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #9ca3af;
  margin-bottom: 12px;
}

.card-info .creator {
  font-weight: 500;
  color: #6b7280;
}

/* 操作按钮 */
.card-actions {
  display: flex;
  gap: 8px;
  margin-top: auto;
}

.card-actions .el-button {
  flex: 1;
}

/* 响应式 */
@media (max-width: 1200px) {
  .project-grid {
    grid-template-columns: 1fr;
  }
}

.avatar-uploader {
  padding-bottom: 10px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.original-price {
  color: #999;
  text-decoration: line-through;
  font-size: 13px;
}

.discounted-price {
  color: #f56c6c;
  font-weight: bold;
  font-size: 14px;
}

.creator-name {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 3px;
}

.create-time {
  color: #999;
  font-size: 13px;
}

.type-name {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 3px;
}

.recommendation-rate {
  font-size: 13px;
  line-height: 1;
}

.recommendation-rate .el-rate {
  display: inline-block;
  height: 20px;
}

.recommendation-rate .el-rate__text {
  color: #e6a23c;
  font-size: 13px;
}

.none {
  display: none;
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.el-tag {
  height: 32px;
  line-height: 30px;
  display: inline-flex;
  align-items: center;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  height: 32px;
  vertical-align: top;
}

.el-drawer__body {
  overflow-y: auto;
}
</style>
